import { Spinner as SpinnerFromVSX } from "@cjdev-internal/visual-stack-x/components/Spinner";
import React from "react";

export const Spinner = ({ props }) => {
  return <SpinnerFromVSX {...props} role="alert" aria-label="loading" />;
};
